import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchDebitNotes = async (query) => {
  const { data } = await apiClient.get(`/debit-notes`, { params: query.queryKey[1] });
  return data;
};

export const useGetDebitNotesHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [debitNotes, setDebitNotes] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['debit_notes', { ...searchQuery }], // A unique key for this query
    queryFn: fetchDebitNotes,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    cacheTime: 0,
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setDebitNotes(fetchedData.debit_notes);
      setTotalDocuments(fetchedData.totalDocuments);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    debitNotes,
    totalDocuments,
    isLoading,
  };
};
